<template>
  <section>
    <twemoji-textarea 
        ref="twemoji"
        :placeholder="$t('留下你的精彩评论吧')"
        :initialContent='input2'
        @contentChanged="contentChanged"
        :emojiData="emojiDataAll" 
        :emojiGroups="emojiGroups" 
        @enterKey="onEnterKey" style="width: 590px;" @click="tewojiClick">
    </twemoji-textarea>
        

  </section>
</template>

<script>
import {
    TwemojiTextarea
  } from '@kevinfaguiar/vue-twemoji-picker';
  import EmojiAllData from '@kevinfaguiar/vue-twemoji-picker/emoji-data/zh/emoji-all-groups.json';
  import EmojiGroups from '@kevinfaguiar/vue-twemoji-picker/emoji-data/emoji-groups.json';
export default {
  name: "comment",
  components: {
      'twemoji-textarea': TwemojiTextarea
  },
  data() {
    return {
        input2:null,
        input1:'',
    };
  },
  props:['type'],
  computed: {
      emojiDataAll() {
          return EmojiAllData;
      },
      emojiGroups() {
          return EmojiGroups;
      }
    },
  created() {
  },
  methods: {
        onEnterKey(e) {
          console.log("ClickedEnter", e);
        },
        //输入框内容改变触发的事件，val返回最新数值
        contentChanged(val) {
          console.log(val)
          this.input2 = val
          if(this.type==1) {
              this.$emit('input',val,1)
          } else if(this.type == 0) {
              this.$emit('input',val,0)
          }
        },
        //清空内容
        clear(){
            this.$refs.twemoji.cleanText()
        },
        //给文本域赋值，例如接口返回数据赋值
        addText(){
            this.$refs.twemoji.addText('最新的数据显示')
        },
        tewojiClick() {
            console.log("twemoji", 1)
        }

  },
  mounted() {
  },
};
</script>

<style scoped lang="scss">

// >>>#emoji-container > #emoji-popup {
//     width: auto !important;
// }
// >>>#emoji-container > #emoji-popup .emoji-popover-inner {
//     width: auto !important;
// }
>>> .emoji-popover-inner {}
>>> #emoji-container > #emoji-popup .emoji-popover-inner {}
>>> .twemoji-textarea-outer > #twemoji-textarea {
  padding-right: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/details/comment/twemoji.vue